




























































import Email from "@/store/entities/email";
import { Component, Prop, Vue } from "vue-property-decorator";
import Ajax from '../../..//lib/ajax';
@Component({})
export default class BulkEmail extends Vue {
  content: any = "";
  emailChips: any[] = [];
  subject: string = "";
    dialog: boolean = true;
    email:Email=new Email;
    @Prop()
  selected: any[];


  async sendBulkEmail() {
    var emailList=this.selected.map(x=>x.email)
    this.email.to=emailList;
  await Ajax.post(
        '/api/services/app/Admin/SendEmailBulk',this.email
      );

      Vue.$toast.success("Email Gönderildi");
      this.closeDialog();


   
  }

  created() {


  }

  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
  }




}
